import styled from "styled-components";

import iconComment from "../../images/ic_edit_ima_icon_image.svg";
import iconNoComment from "../../images/ic_edit_no_comment_image.svg";
import iconCommentDisabled from "../../images/ic_icon_edit_coment_disabled.svg";
import iconCommentDisabledFillNa from "../../images/ic_edit_comment_fill_na_disabled.svg";

import { TOOLTIPS } from "../../utils/tooltipConstants";
import { BaseButton, TooltipBox } from "./BaseButton";

const IconButton = styled(BaseButton)`
  background-color: ${({ theme }) => theme.colors.primaryBlue};
  & :hover > ${TooltipBox} {
    background-color: ${({ theme }) => theme.colors.primaryBlue};
  }
  .image-size-height-width {
    height: 3.5rem;
    width: 3.5rem;
  }
`;

export function CommentButton(props: any) {
  const { tooltipText, onClick } = props;
  const tooltipContent = tooltipText ? tooltipText : TOOLTIPS.comment.text;
  return (
    <IconButton onClick={onClick} tooltip={tooltipContent} {...props}>
      <img
        className="image-size-height-width"
        style={{ cursor: `${props.disabled ? "not-allowed" : "pointer"}` }}
        src={
          props.disabled
            ? props.disabled && props.isFilled
              ? iconCommentDisabled
              : iconCommentDisabledFillNa
            : props.isFilled
            ? iconComment
            : iconNoComment
        }
        alt={tooltipContent}
      />
    </IconButton>
  );
}
